const LOGO_URL = "/logo-new.png";

export default function FooterSection() {
  return (
    <footer data-testid="footer-section" className="bg-[#EFEAE6]">
      <div className="border-t border-[#0A0A0A]/6 mx-6 md:mx-16 lg:mx-24" />

      <div className="py-8 md:py-10 px-6 md:px-16 lg:px-24">
        <div className="max-w-[1200px] mx-auto">
          {/* Main row: logo+text left, links right */}
          <div className="flex flex-col md:flex-row items-center md:items-end justify-between gap-6 md:gap-0">
            {/* Left */}
            <div className="flex items-center gap-[10px]">
              <img
                src={LOGO_URL}
                alt="CinCin Events"
                className="h-24 md:h-28 w-auto"
                style={{ transform: 'translateX(6px)' }}
                data-testid="footer-logo"
              />
              <div>
                <p className="font-serif text-sm tracking-wide text-[#0A0A0A]/75">
                  CinCin Events
                </p>
                <p className="font-light text-[10px] tracking-[0.1em] text-[#8C8C8C]/60 mt-0.5">
                  Designed with intention.
                </p>
              </div>
            </div>

            {/* Right */}
            <div className="flex items-center gap-6 md:pb-1">
              <a
                href="https://www.instagram.com/cincin.in/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="text-[10px] tracking-[0.15em] uppercase font-light text-[#8C8C8C]/60 hover:text-[#0A0A0A] transition-colors duration-300"
              >
                Instagram
              </a>
              <a
                href="mailto:hello@cincinevents.com"
                data-testid="footer-email-link"
                className="text-[10px] tracking-[0.15em] uppercase font-light text-[#8C8C8C]/60 hover:text-[#0A0A0A] transition-colors duration-300"
              >
                Email
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-6 md:mt-8 text-center">
            <p
              data-testid="footer-copyright"
              className="text-[9px] tracking-[0.12em] text-[#8C8C8C]/40 font-light"
            >
              &copy; 2026 CinCin Events. All rights reserved.
              <span className="mx-2">&middot;</span>
              <a href="/faq" className="text-[#8C8C8C]/40 hover:text-[#8C8C8C]/60 transition-colors duration-300">FAQ</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
